import Api from './Api';

const searchLink = (payload) => {
    const path = '/link-search';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

export default {
    searchLink
};
